import React from "react"
import { Link } from "gatsby"
import navigation from "../config/navigation"
import styled from "styled-components"

interface NavigationProps {}

const NavListStyles = styled.ul`
  list-style: none;

  li {
    text-transform: uppercase;
    font-size: 1.4rem;
    letter-spacing: 0.25rem;
    fornt-weight: 700;

    a {
      color: var(--white);
      text-decoration: none;
      padding: 1.4rem;

      &.active {
        text-decoration: underline;
      }
    }
  }
`

export const Navigation = (props: NavigationProps) => {
  return (
    <nav>
      <NavListStyles>
        {navigation.map((navItem, index) => (
          <li key={index}>
            <Link to={navItem.url} activeClassName="active">{navItem.text}</Link>
          </li>
        ))}
      </NavListStyles>
    </nav>
  )
}

export default Navigation
